(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var form = document.getElementById('cart-form');
    if (!form) return;

    // Quantity buttons — update input, then POST via fetch to /cart/change.js
    form.addEventListener('click', function (e) {
      var btn = e.target.closest('.cart-qty__btn');
      if (!btn) return;
      var key   = btn.dataset.key;
      var input = form.querySelector('.cart-qty__input[data-key="' + key + '"]');
      if (!input) return;
      var val = parseInt(input.value, 10) || 0;
      if (btn.dataset.action === 'increment') val = Math.min(val + 1, 99);
      if (btn.dataset.action === 'decrement') val = Math.max(val - 1, 0);
      input.value = val;
      updateLineItem(key, val);
    });

    // Update on direct input change (debounced)
    var debounceTimers = {};
    form.addEventListener('change', function (e) {
      var input = e.target.closest('.cart-qty__input');
      if (!input) return;
      var key = input.dataset.key;
      clearTimeout(debounceTimers[key]);
      debounceTimers[key] = setTimeout(function () {
        updateLineItem(key, parseInt(input.value, 10) || 0);
      }, 400);
    });

    function updateLineItem(key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Update subtotal
        var subtotalEl = document.getElementById('cart-subtotal');
        if (subtotalEl && cart.total_price != null) {
          subtotalEl.textContent = formatMoney(cart.total_price);
        }
        // Remove the row if quantity reached 0
        if (quantity === 0) {
          var row = form.querySelector('.cart-item[data-key="' + key + '"]');
          if (row) row.remove();
        }
        // If cart is now empty, reload to show empty state
        if (cart.item_count === 0) window.location.reload();
        // Update cart count in header if present
        var countEls = document.querySelectorAll('[data-cart-count]');
        countEls.forEach(function (el) { el.textContent = cart.item_count; });
      })
      .catch(function () {});
    }

    function formatMoney(cents) {
      // Use Intl if available; fall back to a generic format
      try {
        var iso = document.documentElement.lang === 'en-GB' ? 'GBP' : 'USD';
        var dataEl = document.getElementById('cart-currency-data');
        if (dataEl) iso = dataEl.dataset.currency;
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: iso }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header   = document.getElementById('site-header');
    var hamburger = header.querySelector('.header__hamburger');
    var nav      = document.getElementById('mobile-menu');
    var backdrop = document.getElementById('mobile-nav-backdrop');
    var closeBtn = nav.querySelector('.mobile-nav__close');

    var heroEnabled = header.dataset.heroEnabled === 'true';
    var SCROLL_THRESHOLD = 30;
    var isScrolled = false;

    function isHomeTemplate() {
      return document.body.classList.contains('template-index');
    }

    // Only meaningful once the page is in the dark hero state; scroll never
    // changes anything on light-header templates.
    function updateScrollState() {
      if (!header.classList.contains('header--dark')) return;
      var shouldBeScrolled = window.scrollY > SCROLL_THRESHOLD;
      if (shouldBeScrolled === isScrolled) return;
      isScrolled = shouldBeScrolled;
      header.classList.toggle('header--scrolled', isScrolled);
    }

    // The header lives outside #main-content, so the theme's client-side
    // page transitions (layout/theme.liquid) never re-render it. Re-derive
    // dark-vs-light from the template-* body class (synced on every swap)
    // instead of trusting the header's own server-rendered initial state,
    // which would otherwise go stale after the first SPA navigation.
    function syncHeaderState() {
      var wantsDark = heroEnabled && isHomeTemplate();
      header.classList.toggle('header--dark', wantsDark);
      isScrolled = !wantsDark;
      header.classList.toggle('header--scrolled', !wantsDark);
      if (wantsDark) updateScrollState();
    }

    if (heroEnabled) {
      window.addEventListener('scroll', updateScrollState, { passive: true });
    }
    document.addEventListener('rosselle:page', syncHeaderState);
    syncHeaderState();

    function openNav() {
      nav.setAttribute('aria-hidden', 'false');
      backdrop.classList.add('is-active');
      hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeNav() {
      nav.setAttribute('aria-hidden', 'true');
      backdrop.classList.remove('is-active');
      hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    hamburger.addEventListener('click', openNav);
    closeBtn.addEventListener('click', closeNav);
    backdrop.addEventListener('click', closeNav);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeNav();
    });

    // Close mobile nav automatically on SPA navigation so the drawer
    // doesn't stay open and body overflow doesn't stay locked.
    document.addEventListener('rosselle:page', closeNav);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.reveal').forEach(function (el) {
      if (typeof IntersectionObserver === 'undefined') {
        el.classList.add('is-visible');
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      io.observe(el);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
